// eslint-disable-next-line import/prefer-default-export
export const REGISTRATION_FIELDS = {
  first: {
    name: 'first',
    autoComplete: 'given-name',
    dataHook: 'register-firstname',
    label: 'First Name',
    error: '',
    value: '',
    section: 'account',
    isRequired: true
  },
  last: {
    name: 'last',
    autoComplete: 'family-name',
    dataHook: 'register-lastname',
    label: 'Last Name',
    error: '',
    value: '',
    section: 'account',
    isRequired: true
  },
  'date-of-birth': {
    name: 'date-of-birth',
    label: 'Date of Birth',
    error: '',
    value: '',
    section: 'account',
    isRequired: true
  },
  username: {
    name: 'username',
    autoComplete: 'username',
    dataHook: 'register-username',
    label: 'Username',
    error: '',
    value: '',
    section: 'account',
    isRequired: true
  },
  email: {
    name: 'email',
    autoComplete: 'email',
    dataHook: 'register-email',
    label: 'Email Address',
    error: '',
    value: '',
    section: 'account',
    isRequired: true,
    redirectUrl: '',
  },
  password: {
    name: 'password',
    autoComplete: 'new-password',
    dataHook: 'register-password',
    label: 'Password',
    error: '',
    value: '',
    section: 'account',
    isRequired: true
  },
  'currency-id': {
    name: 'currency-id',
    label: 'Select Currency',
    error: '',
    value: '',
    section: 'account',
    isRequired: true
  },
  'bonus-code': {
    name: 'bonus-code',
    autoComplete: 'bonus-code',
    dataHook: 'register-bonus',
    label: 'Bonus Code',
    error: '',
    value: '',
    section: 'account',
    isRequired: false
  },
  country: {
    name: 'country',
    autoComplete: 'country-name',
    dataHook: 'register-country',
    label: 'Country of Residence',
    error: '',
    value: '',
    section: 'address',
    isRequired: true
  },
  province: {
    name: 'province',
    autoComplete: 'province-name',
    dataHook: 'register-province',
    label: 'Province',
    error: '',
    value: '',
    section: 'address',
    isRequired: false,
  },
  'address-line-1': {
    name: 'address-line-1',
    autoComplete: 'address-line1',
    dataHook: 'register-address-line-1',
    label: 'Address',
    error: '',
    value: '',
    section: 'address',
    isRequired: true
  },
  'address-line-2': {
    name: 'address-line-2',
    autoComplete: 'address-line2',
    dataHook: 'register-address-line-2',
    label: 'Address 2',
    error: '',
    value: '',
    section: 'address',
    isRequired: false
  },
  city: {
    name: 'city',
    autoComplete: 'city',
    dataHook: 'register-city',
    label: 'City',
    error: '',
    value: '',
    section: 'address',
    isRequired: true
  },
  'post-code': {
    name: 'post-code',
    autoComplete: 'postal-code',
    dataHook: 'register-post-code',
    label: 'Postcode/Zipcode',
    error: '',
    value: '',
    section: 'address',
    isRequired: true
  },
  'phone-number': {
    name: 'phone-number',
    autoComplete: 'phone-number',
    dataHook: 'register-phone-number',
    label: 'Mobile Number',
    value: '',
    section: 'address',
    error: '',
    metadata: {
      prefix: ''
    },
    isRequired: true
  },
  'security-question': {
    name: 'security-question',
    autoComplete: 'security-question',
    dataHook: 'register-security-question',
    label: 'Security Question',
    error: '',
    value: '',
    section: 'join',
    isRequired: true
  },
  answer: {
    name: 'answer',
    autoComplete: 'answer',
    dataHook: 'register-answer',
    label: 'Answer',
    error: '',
    value: '',
    section: 'join',
    isRequired: true
  },
};
